import {Tooltip, Typography} from 'antd';
import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {IFieldMeta, EFieldType} from 'entities/metadata';
import {TEntityValue} from 'modules/data';
import {downloadFileForUrl} from 'modules/data/data-actions';

import {DynamicIcon} from '../../dynamic-icon';

const {Link} = Typography;

interface ITypeValueProps {
    type: EFieldType;
    value: TEntityValue;
    referenceUrl: string | undefined;
}

const TypeValue: FC<ITypeValueProps> = ({
    type,
    value,
    referenceUrl,
}: ITypeValueProps) => {
    const dispatch = useDispatch();
    switch (type) {
    case EFieldType.EMAIL:
        return <Link href={`mailto:${value}`}>{value}</Link>;

    case EFieldType.PHONE:
        return <Link href={`tel:${value}`}>{value}</Link>;

    case EFieldType.ICON_LINK: {
        const onFileDownload = () => {
            dispatch(downloadFileForUrl(referenceUrl));
        };
        return (
            <Tooltip title="">
                <DynamicIcon
                    className="list-modal__download-icon"
                    type="DownloadOutlined"
                    onClick={onFileDownload}
                />
            </Tooltip>
        );
    }

    default:
        return <>{value}</>;
    }
};

interface IListItemProps {
    meta: IFieldMeta;
    value?: TEntityValue;
}

export const ListItem: FC<IListItemProps> = ({
    meta,
    value,
}: IListItemProps) => (
    <div className="list__item">
        <span className="list__item__label">{meta.label}</span>
        {
            (value || meta.type === EFieldType.ICON_LINK) && (
                <TypeValue
                    type={meta.type}
                    value={value}
                    referenceUrl={meta.referenceUrl}
                />
            )
        }
    </div>
);
